
define('template!productAlternativeTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="col-xs-1" style="text-align:center;">\n    ';
 if (imageUrl) { ;
__p += '\n        <img src="' +
((__t = ( imageUrl )) == null ? '' : __t) +
'" style="max-height: 24px; max-width: 30px; object-fit: contain;" />\n    ';
 } ;
__p += '\n</div>\n<div class="col-xs-3">\n    ' +
((__t = ( productCode )) == null ? '' : __t) +
'\n    ';
 if (!direct) { ;
__p += '\n        <span class="alt-indirect-badge">' +
((__t = ( _.i18n('product.indirect') )) == null ? '' : __t) +
'</span>\n    ';
 } ;
__p += '\n</div>\n<div class="col-xs-3" style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">\n    ' +
((__t = ( productName )) == null ? '' : __t) +
'\n</div>\n<div class="col-xs-3" style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">\n    ' +
((__t = ( supplierName || '' )) == null ? '' : __t) +
'\n</div>\n';
 if (direct) { ;
__p += '\n<div class="btn btn-remove-alternative p-l-0 p-r-0 p-t-0 p-b-0 m-b-0 m-t-0 col-xs-1" style="height: 20px; text-align:center;">\n    <i class="mdi-content-remove"></i>\n</div>\n';
 } else { ;
__p += '\n<div class="col-xs-1"></div>\n';
 } ;
__p += '\n';

}
return __p
};});

